export default __webpack_public_path__ + "static/media/groupStudents2026.c108c3a7.png";